import { useState, useEffect } from 'react';
import { Card, Space, Tooltip} from 'antd';
import { APIClient } from '../../helpers/api_helper';
import Breadcrumb from '../../Common/Breadcrumb';
import CompanyDrawer from '../../Common/CompanyDrawer';
import utils from '../../Common/utils';
import { Pagination, Table, Button } from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import {EditFilled, MergeCellsOutlined} from '@ant-design/icons';
import MergeModal from '../../Common/MergeModal';
import { setInitialFilterConf, updateFilterData } from '../../slices/filters/thunk'
import { loadCompanies as reloadCompaniesGlobal } from '../../slices/thunk';
import { useSelector, useDispatch } from "react-redux";

const api = new APIClient();


const CompaniesList = (props) => {
  document.title = "Podjetja" + process.env.REACT_APP_PAGE_TITLE;

  const dispatch = useDispatch();
  const [companiesData, setCompaniesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const filterdata = useSelector((state) => state.Filterdata.data)
  const searchPending = useSelector((state) => state.Filterdata.searchPending)

  const [editedId, setEditedId] = useState(null);
  const [open, setOpen] = useState(false);

  const [mergeModalOpen, setMergeModalOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: {},
      // Only the normal search box.
      hidden: ['relateds_group', 'intent_type', 'intent_checkboxes_group', 'dt_range'],
      disabled: []
    }))
  }, []);

  const onEdit = (id) => {
    setEditedId(id)
    setOpen(true);
  }

  const loadCompanies = () => {
    setLoading(true);
    api.get('/api/companies/', filterdata)
      .then((resp) => setCompaniesData(resp))
      .finally(() => setLoading(false));
  }

  const columns = [
    {title: 'Naslov', dataIndex: 'title'},
    {title: 'Uredi', key: 'edit', render: r => <Button size='small' onClick={ev => onEdit(r.id)}><EditFilled/></Button>}
  ]

  useEffect(() => {
      loadCompanies()
  }, [filterdata]);


  return (
    <>
      <CompanyDrawer
        open={open}
        onCancel={() => {
          setOpen(false);
          setEditedId(null);
        }}
        onDone={() => {
          loadCompanies(filterdata);
          setEditedId(null);
          setOpen(false);
        }}
        id={editedId}
      />

      <MergeModal
        open={mergeModalOpen}
        title='Združitev podjetij'
        mergeApiUrl={"/api/companies/merge/"}
        mergeInfoApiUrl={"/api/companies/merge_info/"}
        items={companiesData?.results?.filter(x => selectedIds.includes(x.id))}
        onCancel={() => setMergeModalOpen(false)}
        onDone={() => {
          loadCompanies(filterdata);
          dispatch(reloadCompaniesGlobal());
          setMergeModalOpen(false);
        }}
        id={editedId}
      />

      <Breadcrumb parentTitle="Statični podatki" pageTitle="Podjetja" />

      <Card
        title='Podjetja'
        extra={
          <Space>
            <Tooltip title={'Izberite nekaj podjetij za združitev!'}>
              <Button
                disabled={selectedIds.length == 0}
                onClick={ev => setMergeModalOpen(true)}
                icon={<MergeCellsOutlined />}
              />
            </Tooltip>
            <Button
              onClick={ev => {
                setEditedId(null)
                setOpen(true)
              }}
              icon={<PlusOutlined />}
            />
          </Space>
        }
      >
        <Table
            size="small"
            loading={loading || searchPending}
            columns={columns}
            dataSource={companiesData?.results || []}
            pagination={false}
            rowKey={obj => obj.id}
            rowSelection={{
            onChange: (selectedIds) => setSelectedIds(selectedIds)}}
            rowClassName={(record) => {}}
        />
        <Pagination
            current={filterdata.page}
            onChange={pInx => dispatch(updateFilterData({page: pInx}))}
            showSizeChanger={false}
            {...utils.processPagination(companiesData?.pagination)}
        />
      </Card>
    </>
  )
}

export default CompaniesList;
